// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"hero-module--wrapper--3qwTy","bg":"hero-module--bg--28BvA","content":"hero-module--content--h18J3"};